import React from "react";

/**
 * Wraps React.lazy with a single retry after a delay to handle stale chunk references
 * after deployments [SEPAHELD-FRONTEND-1F]
 */
export default function lazyWithRetry(importFn) {
    return React.lazy(() =>
        importFn().catch(() => {
            return new Promise((resolve) => {
                setTimeout(() => resolve(importFn()), 1500);
            });
        })
    );
}
